import { FC, useState } from 'react'
import { useOktaAuth } from '@okta/okta-react'

import {
	Button,
	Container,
	Form,
	SpaceBetween,
	Textarea
} from '@cloudscape-design/components'

import useRejectGcpProject from '../../../hooks/mutate/useRejectGcpProject'
import { gcpProjectRejectionRequest } from '../../../types/gcpProject'

interface RejectionFormProps {
	thisgcpProjectID: string
	shouldShowRejectionForm: (shouldShow: boolean) => void
}

const RejectionForm: FC<RejectionFormProps> = ({
	thisgcpProjectID,
	shouldShowRejectionForm
}) => {
	const { authState } = useOktaAuth()
	const thisUserEmail = authState?.idToken?.claims.email as string

	const [commentText, setCommentText] = useState('')

	const { mutate: rejectgcpProject, isLoading } =
		useRejectGcpProject(thisgcpProjectID)

	const _handleReject = () => {
		const rejectionRequest: gcpProjectRejectionRequest = {
			action: 'REJECT',
			gcpProjectID: thisgcpProjectID,
			commenterID: thisUserEmail,
			comment: commentText
		}

		rejectgcpProject(rejectionRequest, {
			onSuccess: () => {
				shouldShowRejectionForm(false)
				setCommentText('')
			}
		})
	}

	return (
		<Form
			actions={
				<SpaceBetween direction="horizontal" size="xs">
					<Button variant="link" onClick={() => shouldShowRejectionForm(false)}>
						Cancel
					</Button>
					<Button variant="primary" loading={isLoading} onClick={_handleReject}>
						Reject
					</Button>
				</SpaceBetween>
			}
		>
			<Container>
				<SpaceBetween direction="vertical" size="l">
					<Textarea
						onChange={({ detail }) => setCommentText(detail.value)}
						value={commentText}
						placeholder="Reason for rejection"
					/>
				</SpaceBetween>
			</Container>
		</Form>
	)
}

export default RejectionForm
